module.exports = __webpack_public_path__ + "img/Sedan_Front.c9097238.svg";